import * as os from "os";

import { IApiEndpoints, IProxyEndpoints } from "./models";
const projectName = "MG Tools";
const projectIdentifier = "ksys345";
const port = 3345;
const portOffset = 1000;
const useProxy = false;

export const FRONT_END_CLIENT_TYPES = [
	{ code: 'adv', text: "adviser" },
	{ code: 'adv', text: "Adviser" },
	{ code: 'adv', text: "Advisers" },
	{ code: 'adv', text: "advisers" },
	{ code: 'pri', text: "Investor" },
	{ code: 'pri', text: "investor" },
	{ code: 'pri', text: "End Investor" },
	{ code: 'pri', text: "end investor" },
	{ code: 'pri', text: "End Investors" },
	{ code: 'pri', text: "end investors" },
	{ code: 'pri', text: "Private Investors" },
	{ code: 'pri', text: "private investors" },
	{ code: 'diw', text: "Discretionary" },
	{ code: 'diw', text: "discretionary" },
	{ code: 'diw', text: "Discretionary Wealth" },
	{ code: 'diw', text: "discretionary wealth" },
	{ code: 'diw', text: "discretionary" },
	{ code: 'cha', text: "Charities" },
	{ code: 'cha', text: "charities" },
	{ code: 'crp', text: "CorporateTrustees" },
	{ code: 'crp', text: "corporatetrustees" },
	{ code: 'crp', text: "Corporate Trustees" },
	{ code: 'crp', text: "corporate trustees" },
	{ code: 'crp', text: "Trustees" },
	{ code: 'crp', text: "trustees" },
	{ code: 'ins', text: "Institutional" },
	{ code: 'ins', text: "institutional" },
	{ code: 'ins', text: "Institutions" },
	{ code: 'ins', text: "institutions" },
	{ code: 'jrn', text: "Journalists" },
	{ code: 'jrn', text: "journalists" },
	{ code: 'jrn', text: "Media" },
	{ code: 'jrn', text: "media" },
	{ code: 'jrn', text: "media-centre" },
	{ code: 'dtc', text: "direct to consumer" },
	{ code: 'dtc', text: "Direct to Consumer" },
	{ code: 'dtc', text: "Direct to consumer" }
];

const localBaseElements = {
	'auth': ':12001/',
	'config': ':12002/',
	'dataloader': ':12003/',
	'fund': ':12004/',
	'docloader': ':12005/',
	'documents': ':12006/',
	'layout': ':12009/'
};
const remoteBaseElements = {
	'auth': '/auth/',
	'config': '/config/',
	'dataloader': '/dataloader/',
	'fund': '/fund/',
	'docloader': '/docloader/',
	'documents': '/documents/',
	'layout': '/layout/'
};

function generateProxyApiEndPoints(host, baseElements): IProxyEndpoints {
	let response = {
		"auth": `${host}${baseElements.auth}`,
		"config": `${host}${baseElements.config}`,
		"dataloader": `${host}${baseElements.dataloader}`,
		"fund": `${host}${baseElements.fund}`,
		"docloader": `${host}${baseElements.docloader}`,
		"documents": `${host}${baseElements.documents}`,
		"layout": `${host}${baseElements.layout}`
	};
	return response;
}

function generateApiEndPoints(host, baseElements): IApiEndpoints {
	let response = JSON.parse(JSON.stringify(ENDPOINTS));
	for (let key of Object.keys(response)) {
		let subEndpoints = response[key];
		let baseElement = baseElements[key];
		if (subEndpoints && baseElement) {
			for (let subKey of Object.keys(subEndpoints)) {
				let endpointValue = subEndpoints[subKey];
				if (endpointValue && endpointValue !== "") {
					subEndpoints[subKey] = `${host}${baseElement}${endpointValue}`;
				}
			}
		}
	}
	return response;
}

export const ENDPOINTS: IApiEndpoints = {
	"auth": {},
	"config": {
		"translateLabels": `translateLabels`,
		"listdisclaimers": `listdisclaimers`,
		"listcommentaries": `listcommentaries`,
		"listfundlists": `listfundlists`,
	},
	"dataloader": {},
	"fund": {
		"searchEntity": `searchentity`,
		"getFilters": `getFilters`,
		"fundmanagerpicture": `fundmanagerpicture`,
	},
	"docloader": {},
	"documents": {
		"searchDocuments": `searchDocuments`,
		"retrieveDocumentZip": `retrieveDocumentZip`
	},
	"layout": {
		"retrieveLayoutConfiguration": `retrieveLayoutConfiguration`
	}

};

export const appConfig = {
	projectName,
	projectIdentifier,
	fundExplorer: "fund-centre/oeic-fund-explorer/OEIC/uk/diw/en",
	miniFundExplorer: "mini-fund-explorer/OEIC/uk/diw/en",
	rankia: "rankia/OEIC/es/pri/en",
	fundPage: "funds/global-basics-fund/gb0030932452/uk/diw/en",
	port,
	portOffset,
	environment: null,
	envDetails: {
		local: {
			baseurl: `http://${os.hostname()}:${port + portOffset}/`,
			// RELEASE //
			fundPressHost: "https://api-rel.fundpress.io",
			token: "72f1191f-4015-4596-8f5f-5ef17a7cb07b",
			// STAGING //
			// token: "437fc4d6-6b5e-429e-ad9c-e7917e1d4233",
			// fundPressHost: "https://api.fundpress.io",
			// PRODUCTION //
			// token: "fc92cd68-b71c-4994-8e23-da1971402ae8",
			// fundPressHost: "https://api.fundpress.io",
			isRemote: true,
			fundExplorerUrls: {
				pri: {
					OEIC: "funds/fund-explorer"
				},
				cha: {
					OEIC: "funds/fund-explorer"
				},
				adv: {
					OEIC: "fund-centre/fund-explorer"
				},
				diw: {
					OEIC: "fund-centre/oeic-fund-explorer",
					ICAV: "fund-centre/icav-fund-explorer"
				},
				ins: {
					PPL: "resource-centre/pooled-funds-explorer"
				}
			}
		},
		development: {
			baseurl: `https://dev.kurtosys.io/tools/${projectIdentifier}/`,
			// DEVELOPMENT
			fundPressHost: "https://api-rel.fundpress.io",
			token: "72f1191f-4015-4596-8f5f-5ef17a7cb07b",
			// PRODUCTION
			// token: "fc92cd68-b71c-4994-8e23-da1971402ae8",
			// fundPressHost: "https://api.fundpress.io",
			isRemote: true,
			fundExplorerUrls: {
				pri: {
					OEIC: "funds/fund-explorer"
				},
				cha: {
					OEIC: "funds/fund-explorer"
				},
				adv: {
					OEIC: "fund-centre/fund-explorer"
				},
				diw: {
					OEIC: "fund-centre/oeic-fund-explorer",
					ICAV: "fund-centre/icav-fund-explorer"
				},
				ins: {
					PPL: "resource-centre/pooled-funds-explorer"
				}
			}
		},
		release: {
			baseurl: `https://release.kurtosys.io/tools/${projectIdentifier}/`,
			fundPressHost: "https://api-rel.fundpress.io",
			token: "72f1191f-4015-4596-8f5f-5ef17a7cb07b",
			isRemote: true,
			fundExplorerUrls: {
				pri: {
					OEIC: "funds/fund-explorer"
				},
				cha: {
					OEIC: "funds/fund-explorer"
				},
				adv: {
					OEIC: "fund-centre/fund-explorer"
				},
				diw: {
					OEIC: "fund-centre/oeic-fund-explorer",
					ICAV: "fund-centre/icav-fund-explorer"
				},
				ins: {
					PPL: "resource-centre/pooled-funds-explorer"
				}
			}
		},
		staging: {
			baseurl: `https://api-rel-uk.kurtosys.io/tools/${projectIdentifier}/`,
			fundPressHost: "https://api.fundpress.io",
			token: "437fc4d6-6b5e-429e-ad9c-e7917e1d4233",
			isRemote: true,
			fundExplorerUrls: {
				pri: {
					OEIC: "funds/fund-explorer"
				},
				cha: {
					OEIC: "funds/fund-explorer"
				},
				adv: {
					OEIC: "fund-centre/fund-explorer"
				},
				diw: {
					OEIC: "fund-centre/oeic-fund-explorer",
					ICAV: "fund-centre/icav-fund-explorer"
				},
				ins: {
					PPL: "resource-centre/pooled-funds-explorer"
				}
			}
		},
		production: {
			token: "fc92cd68-b71c-4994-8e23-da1971402ae8",
			baseurl: `https://api.kurtosys.io/tools/${projectIdentifier}/`,
			fundPressHost: "https://api.fundpress.io",
			isRemote: true,
			fundExplorerUrls: {
				pri: {
					OEIC: "fund-prices-performance"
				},
				cha: {
					OEIC: "prices"
				},
				adv: {
					OEIC: "fund-prices-performance"
				},
				diw: {
					OEIC: "fund-centre/oeic-fund-prices-performance",
					ICAV: "fund-centre/icav-fund-prices-performance"
				},
				ins: {
					PPL: "resource-centre/pooledfundprices"
				}
			}
		}
	}
};

for (let key of Object.keys(appConfig.envDetails)) {
	let envDetails = appConfig.envDetails[key];
	let { token, baseurl, endpoints, fundPressHost, isRemote } = envDetails;
	envDetails.proxyUrlBase = `${baseurl}api`;
	envDetails.proxyEndpoints = generateProxyApiEndPoints(fundPressHost, isRemote ? remoteBaseElements : localBaseElements);
	envDetails.endpoints = generateApiEndPoints(useProxy ? envDetails.proxyUrlBase : fundPressHost, isRemote || useProxy ? remoteBaseElements : localBaseElements);
}


// WEBPACK FOOTER //
// ./src/config.ts